if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        this._keyboardExpand = false;

        const button = this.querySelector('button');

        button.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            this._keyboardExpand = true;
          }
        });

        button.addEventListener('click', (event) => {
          const parentDisplay = event.target.closest('.parent-display');
          const isExpanding = !this.querySelector('.label-show-more')?.classList.contains('hidden');
          const fromKeyboard = this._keyboardExpand;
          this._keyboardExpand = false;

          this.expandShowMore(event);

          if (isExpanding) {
            this.focusNextRevealedItem(parentDisplay, fromKeyboard);
          }
        });
      }

      getItemFocusTarget(item) {
        if (!item) return null;
        return item.querySelector('label[tabindex="0"]:not(.disabled)');
      }

      focusNextRevealedItem(parentDisplay, fromKeyboard) {
        const firstRevealedItem = parentDisplay?.querySelector('.show-more-item:not(.hidden)');
        const focusTarget = this.getItemFocusTarget(firstRevealedItem);

        if (!focusTarget) return;

        const applyFocus = () => {
          focusTarget.dataset.suppressActivation = 'true';

          const suppressActivation = (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            event.stopImmediatePropagation();
          };

          focusTarget.addEventListener('keydown', suppressActivation, { capture: true, once: true });
          focusTarget.addEventListener('keyup', suppressActivation, { capture: true, once: true });

          if (typeof theme !== 'undefined' && theme.applyFocusVisible) {
            theme.applyFocusVisible(focusTarget);
          } else {
            focusTarget.focus({ preventScroll: true });
          }

          window.setTimeout(() => {
            delete focusTarget.dataset.suppressActivation;
          }, 100);
        };

        if (fromKeyboard) {
          focusTarget.dataset.suppressActivation = 'true';
          setTimeout(applyFocus, 0);
          return;
        }

        applyFocus();
      }

      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }

        requestAnimationFrame(() => {
          this.refreshCollapsibleDetailsHeight(parentDisplay);
        });
      }

      refreshCollapsibleDetailsHeight(container) {
        const details = container?.closest('details[is="collapsible-details"]');
        if (!details || typeof details.refreshHeight !== 'function') return;
        details.refreshHeight();
      }
    }
  );
}
